export default "__VITE_ASSET__BNQvZMqr__"